/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-use-before-define */
import dayjs from 'dayjs';
import {
  DraftingAccrediationStorePayload, DraftingAccrediation, ContactSubmission, FilemakerCreateDrafter,
} from '../models';
import { SubmissionSource, RequestStatus } from '../models/enums';

const buildCreatePayload = (payload: DraftingAccrediationStorePayload): DraftingAccrediation => {
  const applicant: ContactSubmission = {
    firstName: payload.applicantFirstName,
    lastName: payload.applicantLastName,
    jobTitle: payload.titlePosition,
    email: payload.applicantEmail,
    phone: payload.applicantPhone,
    fax: payload.applicantFax,
    source: SubmissionSource.DraftingAccrediation,
  };

  const reference1: ContactSubmission = {
    firstName: payload.referenceFirstName,
    lastName: payload.referenceLastName,
    jobTitle: payload.referenceTitlePosition,
    email: payload.referenceEmailAddress,
    phone: payload.referencePhone,
    fax: payload.referenceFax,
    source: SubmissionSource.DraftingAccrediation,
  };

  const reference2: ContactSubmission = {
    firstName: payload.secondReferenceFirstName,
    lastName: payload.secondReferenceLastName,
    jobTitle: payload.secondReferenceTitlePosition,
    email: payload.secondReferenceEmailAddress,
    phone: payload.secondReferencePhone,
    fax: payload.secondReferenceFax,
    source: SubmissionSource.DraftingAccrediation,
  };

  return {
    applicant,
    revisedApplicant: applicant,

    applicantCountry: payload.applicantCountry,
    revisedApplicantCountry: payload.applicantCountry,

    applicantAddressLine1: payload.applicantCompanyAddressLine1,
    revisedApplicantAddressLine1: payload.applicantCompanyAddressLine1,

    applicantAddressLine2: payload.applicantCompanyAddressLine2,
    revisedApplicantAddressLine2: payload.applicantCompanyAddressLine2,

    applicantCity: payload.applicantCompanyCity,
    revisedApplicantCity: payload.applicantCompanyCity,

    applicantState: payload.applicantCompanyCity,
    revisedApplicantState: payload.applicantCompanyCity,

    applicantZip: payload.applicantCompanyZip,
    revisedApplicantZip: payload.applicantCompanyZip,

    draftingExperience: payload.draftingExperience,
    revisedDraftingExperience: payload.draftingExperience,

    aWIStandards: JSON.stringify(payload.awiStandards),
    revisedAWIStandards: JSON.stringify(payload.awiStandards),

    howDidYouHearAboutProgram: payload.referralInfo !== 'Other' ? payload.referralInfo : payload.otherReferred,
    revisedHowDidYouHearAboutProgram: payload.referralInfo !== 'Other' ? payload.referralInfo : payload.otherReferred,

    reference1Country: payload.referenceCountry,
    revisedReference1Country: payload.referenceCountry,

    reference1AddressLine1: payload.referenceAddressLineOne,
    revisedReference1AddressLine1: payload.referenceAddressLineOne,

    reference1AddressLine2: payload.referenceAddressLineTwo,
    revisedReference1AddressLine2: payload.referenceAddressLineTwo,

    reference1City: payload.referenceCity,
    revisedReference1City: payload.referenceCity,

    reference1StateProvince: payload.referenceState,
    revisedReference1StateProvince: payload.referenceState,

    reference1Zip: payload.referenceZipCode,
    revisedReference1Zip: payload.referenceZipCode,

    reference1,
    revisedReference1: reference1,

    reference2,
    revisedReference2: reference2,

    reference2Country: payload.secondReferenceCountry,
    revisedReference2Country: payload.secondReferenceCountry,

    reference2AddressLine1: payload.secondReferenceAddressLineOne,
    revisedReference2AddressLine1: payload.secondReferenceAddressLineOne,

    reference2AddressLine2: payload.secondReferenceAddressLineTwo,
    revisedReference2AddressLine2: payload.secondReferenceAddressLineTwo,

    reference2City: payload.secondReferenceCity,
    revisedReference2City: payload.secondReferenceCity,

    reference2StateProvince: payload.secondReferenceState,
    revisedReference2StateProvince: payload.secondReferenceState,

    reference2Zip: payload.secondReferenceZipCode,
    revisedReference2Zip: payload.secondReferenceZipCode,

    status: RequestStatus.Pending,
  };
};

const mapResponseToFileMakerCreateDrafter = (payload: DraftingAccrediation): FilemakerCreateDrafter => ({
  Email: payload.revisedApplicant.email,
  'Name First': payload.revisedApplicant.firstName,
  'Name Last': payload.revisedApplicant.lastName,
  Address1: payload.revisedApplicantAddressLine1,
  Address2: payload.revisedApplicantAddressLine2,
  Phone: payload.revisedApplicant.phone,
  Experience: payload.revisedDraftingExperience,
  City: payload.revisedApplicantCity,
  State: payload.revisedApplicantState,
  Zip: payload.revisedApplicantZip,
  'Application Date': dayjs(payload.createdAt).format('MM/DD/YYYY'),
  Expiration_Date: dayjs(payload.createdAt).add(6, 'month').format('MM/DD/YYYY'),
  'Application Expiration Date': dayjs(payload.createdAt).add(6, 'month').format('MM/DD/YYYY'),
  QCP_Code: 'AIDA', // This may need to be flexible? Unsure atm
  Status: 'QCP Info Sent',
});


export default {
  buildCreatePayload,
  mapResponseToFileMakerCreateDrafter,
};